var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2362_2297)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "#FFCB05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 33.0601H27.2193L26.3343 34.2529H11",
    fill: "#D71635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30.8091H28.874L27.9889 32.0212H11",
    fill: "#D71635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 35.292H25.5839L24.6989 36.4849H11",
    fill: "#D71635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 34.2529H114.838L115.723 33.0601H131",
    fill: "#D71635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 36.4849H113.184L114.069 35.292H131",
    fill: "#D71635"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 30.8091H131V32.0212H116.474",
    fill: "#D71635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.719 36.4846L34.415 26.0181C34.415 26.0181 42.9575 26.0181 43.9773 26.0181C45.0355 26.0181 45.0162 26.4221 44.4967 27.1147C43.9773 27.8266 43.073 29.0387 42.5535 29.7699C42.2841 30.1354 41.7839 30.8088 43.4193 30.8088C45.1317 30.8088 56.2139 30.8088 56.2139 30.8088C55.1557 32.2711 51.6925 36.4846 45.4972 36.4846C40.4756 36.4846 26.719 36.4846 26.719 36.4846Z",
    fill: "#D71635"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.817 30.8091L66.6419 36.4849H55.6174L59.7925 30.8091",
    fill: "#D71635"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7477 30.8091L82.5727 36.4849H71.5674L75.7425 30.8091",
    fill: "#D71635"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3266 30.8091C90.3266 30.8091 89.5185 31.9058 89.1337 32.4445C87.7484 34.3108 88.9798 36.4849 93.4819 36.4849C98.696 36.4849 111.163 36.4849 111.163 36.4849L115.358 30.8091",
    fill: "#D71635"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1063 19.5151L28.2776 24.7292C28.2776 24.7292 48.1525 24.7292 49.1722 24.7292C50.2304 24.7292 50.2112 25.1332 49.6917 25.8259C49.1722 26.5377 48.2872 27.7691 47.7485 28.5002C47.4791 28.8658 46.9789 29.5392 48.6143 29.5392C50.3266 29.5392 57.1568 29.5392 57.1568 29.5392C57.1568 29.5392 58.5421 27.6729 59.6965 26.0952C61.2742 23.9596 59.8312 19.5344 54.2131 19.5344C49.1915 19.5151 32.1063 19.5151 32.1063 19.5151Z",
    fill: "#D71635"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6906 29.5392H60.7546L68.1236 19.5151H79.1288L74.9153 25.2679H79.8215L84.0543 19.5151H95.0595",
    fill: "#D71635"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.317 19.5151L102.948 29.5199H91.2886L98.6575 19.5151",
    fill: "#D71635"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2362_2297",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.d61e18962456cfef23709343166e0237.svg";
export { ForwardRef as ReactComponent };